import {
  IRefundSchema,
  REFUND_STATUS_DISPLAY,
  RefundReasonEnum,
} from '@monetize/types/app';
import { MButton } from '../../../components/Monetize';
import { createColumnHelper } from '../../../components/Monetize/DataTableNew/appTable';
import { actionCatalogColumn } from '../../../components/Monetize/DataTableNew/columnCatalog/structuralColumns';
import {
  ColumnCatalog,
  ColumnContextBase,
} from '../../../components/Monetize/DataTableNew/columnCatalog/types';
import {
  currencyBodyTemplate,
  dateBodyTemplate,
  dateTimeBodyTemplate,
  enumDisplayBodyTemplate,
  getColHeaderFilters,
  getColHeaderWithSize,
  getColumnFilterValuesForEnum,
  idBodyTemplate,
} from '../../../components/Monetize/DataTableNew/tableUtilsNew';

const columnHelper = createColumnHelper<IRefundSchema>();

const statusFilterValues = getColumnFilterValuesForEnum(
  RefundReasonEnum,
  REFUND_STATUS_DISPLAY,
);

export interface AccountRefundListColumnContext extends ColumnContextBase<IRefundSchema> {
  onPaymentMethodClick: (id: string) => void;
}

/** tableId: external (hook-managed filters) */
export const ACCOUNT_REFUND_LIST_CATALOG: ColumnCatalog<
  IRefundSchema,
  AccountRefundListColumnContext
> = [
  {
    id: 'id',
    label: 'Refund ID',
    customizable: false,
    build: () =>
      columnHelper.accessor('id', {
        ...getColHeaderWithSize('Refund ID', 200),
        cell: idBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'paymentMethodId',
    label: 'Payment Method',
    build: ({ onPaymentMethodClick }) =>
      columnHelper.accessor('paymentMethodId', {
        ...getColHeaderWithSize('Payment Method', 200),
        cell: ({ row }) => {
          const { paymentMethodId } = row.original;
          if (!paymentMethodId) {
            return null;
          }
          return (
            <MButton
              variant="link"
              fontWeight="400"
              onClick={(ev) => {
                ev.stopPropagation();
                onPaymentMethodClick(paymentMethodId);
              }}
            >
              {paymentMethodId}
            </MButton>
          );
        },
        enableSorting: false,
      }),
  },
  {
    id: 'settledDate',
    label: 'Settled Date',
    build: () =>
      columnHelper.accessor('settledDate', {
        ...getColHeaderWithSize('Settled Date', 170),
        ...getColHeaderFilters('DATE'),
        cell: dateBodyTemplate(),
        enableSorting: true,
      }),
  },
  {
    id: 'status',
    label: 'Status',
    build: () =>
      columnHelper.accessor('status', {
        ...getColHeaderWithSize('Status', 150),
        cell: enumDisplayBodyTemplate({
          displayMap: REFUND_STATUS_DISPLAY,
        }),
        enableSorting: true,
        ...getColHeaderFilters('SET', {
          predefinedFilterValues: statusFilterValues,
        }),
      }),
  },
  {
    id: 'amount',
    label: 'Amount',
    build: () =>
      columnHelper.accessor('amount', {
        ...getColHeaderWithSize('Amount', 150),
        cell: currencyBodyTemplate({
          currencyProperty: 'currency',
        }),
        enableSorting: true,
      }),
  },
  {
    id: 'modifyDate',
    label: 'Updated',
    build: () =>
      columnHelper.accessor('modifyDate', {
        ...getColHeaderWithSize('Updated', 170),
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
      }),
  },
  {
    id: 'createDate',
    label: 'Created',
    build: () =>
      columnHelper.accessor('createDate', {
        ...getColHeaderWithSize('Created', 170),
        ...getColHeaderFilters('DATE'),
        cell: dateTimeBodyTemplate(),
      }),
  },
  actionCatalogColumn<IRefundSchema>(),
];
